import React from 'react';
import './App.css';
import FileUploadSystem from './components/FileUploadSystem';

function App() {
  return (
    <div className="app">
      <header>
        <h1>Cosknow Exam Content Portal</h1>
        <p>Upload your files and discuss course materials</p>
      </header>
      
      <main>
        <FileUploadSystem />
      </main>
      
      <footer>
        <p>&copy; {new Date().getFullYear()} Cosknow Learning Platform</p>
      </footer>
    </div>
  );
}

export default App;